import * as Yup from "yup";


export const QuestionSchema = Yup.object().shape({
    question: Yup.string().trim()
        .required('Question required'),
    
    option1: Yup.string().trim()
        .required('Option1 required'),
    option2: Yup.string().trim()
        .required('Option2 required'),
    option3: Yup.string().trim()
        .required('Option3 required'),
    correct: Yup.string().trim()
        .required('Correct answer required'),
    
})